const SETTINGS = {
  emergencyPhoneNumber: '+31\u00A088\u00A0112\u00A01816'
}

export default SETTINGS
